// Custom TailwindCSS modals for confirm dialogs

const Rails = require("@rails/ujs")

// Cache a copy of the old Rails.confirm since we'll override it when the modal opens
const old_confirm = Rails.confirm;

// Elements we want to listen to for data-confirm
const elements = ['a[data-confirm]', 'button[data-confirm]', 'input[type=submit][data-confirm]']

const escapeHtml = (text) => {
  const div = document.createElement("div")
  div.textContent = text
  return div.innerHTML
}

const createConfirmModal = (element) => {
  var id = 'confirm-modal-' + String(Math.random()).slice(2, -1);
  var confirm = escapeHtml(element.dataset.confirm)
  // Optional per-link button labels: data-confirm-commit / data-confirm-cancel
  var commitLabel = escapeHtml(element.dataset.confirmCommit || "Confirm")
  var cancelLabel = escapeHtml(element.dataset.confirmCancel || "Cancel")

  // Mounted on <body> (not next to the link) so it never inherits styles,
  // transforms or overflow from dropdowns / table cells it was triggered from.
  var content = `
    <div id="${id}" role="dialog" aria-modal="true" class="fixed inset-0 z-[999] flex items-center justify-center bg-gray-900/50 p-4 text-left whitespace-normal">
      <div data-behavior="panel" class="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        <div class="flex items-start gap-4">
          <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-100">
            <svg class="h-5 w-5 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" /></svg>
          </div>
          <p class="min-w-0 flex-1 break-words pt-2 text-sm leading-6 text-gray-700">${confirm}</p>
        </div>

        <div class="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button type="button" data-behavior="cancel" class="inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">${cancelLabel}</button>
          <button type="button" data-behavior="commit" class="inline-flex justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">${commitLabel}</button>
        </div>
      </div>
    </div>
  `

  document.body.insertAdjacentHTML('beforeend', content)

  var modal = document.getElementById(id)
  element.dataset.confirmModal = `#${id}`

  const close = () => {
    element.removeAttribute("data-confirm-modal")
    document.removeEventListener("keydown", onKeydown)
    modal.remove()
  }

  const onKeydown = (event) => {
    if(event.key === "Escape") {
      event.preventDefault()
      close()
    }
  }
  document.addEventListener("keydown", onKeydown)

  // Clicking the dimmed backdrop cancels
  modal.addEventListener("click", (event) => {
    if (event.target === modal) close()
  })

  modal.querySelector("[data-behavior='cancel']").addEventListener("click", (event) => {
    event.preventDefault()
    close()
  })
  modal.querySelector("[data-behavior='commit']").addEventListener("click", (event) => {
    event.preventDefault()

    // Allow the confirm to go through
    Rails.confirm = () => { return true }

    // Click the link again
    element.click()

    // Remove the confirm attribute and modal
    Rails.confirm = old_confirm
    close()
  })

  modal.querySelector("[data-behavior='commit']").focus()
  return modal
}

// Checks if confirm modal is open
const confirmModalOpen = (element) => {
  return !!element.dataset.confirmModal;
}

const handleConfirm = (event) => {
  // If there is a modal open, let the second confirm click through
  if (confirmModalOpen(event.target)) {
    return true

  // First click, we need to spawn the modal
  } else {
    createConfirmModal(event.target)
    return false
  }
}

// When a Rails confirm event fires, we'll handle it
Rails.delegate(document, elements.join(', '), 'confirm', handleConfirm)
